export { default } from "./DispensariesCarouselView";
